"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnvilSelectHeader = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../../");
var utils_1 = require("../utils");
var utilities_1 = require("../../../utilities");
exports.AnvilSelectHeader = react_1.default.memo(function (_a) {
    var className = _a.className, filter = _a.filter, filtersApplied = _a.filtersApplied, onFilterClick = _a.onFilterClick, search = _a.search, title = _a.title, closeSelectHandler = _a.closeSelectHandler, props = __rest(_a, ["className", "filter", "filtersApplied", "onFilterClick", "search", "title", "closeSelectHandler"]);
    var _b = react_1.default.useContext(utils_1.FocusContext), focusState = _b.focusState, focusDispatch = _b.focusDispatch;
    var searchFocus = focusState.searchFocus, filterFocus = focusState.filterFocus;
    var filterRef = react_1.default.useRef(null);
    react_1.default.useEffect(function () {
        var _a;
        filterFocus && ((_a = filterRef.current) === null || _a === void 0 ? void 0 : _a.focus());
    }, [filterFocus, filterRef]);
    var handleKeyDown = function (e) {
        var _a;
        var target = e.target;
        if (e.key === utilities_1.keys.esc) {
            e.preventDefault();
            closeSelectHandler();
            return;
        }
        if (target.nodeName === 'INPUT') {
            if (e.key === utilities_1.keys.tab && e.shiftKey) {
                e.preventDefault();
                closeSelectHandler();
                return;
            }
            if (e.key === utilities_1.keys.down) {
                e.preventDefault();
                utils_1.focusFirstOption(e.target, closeSelectHandler);
                return;
            }
            if (e.key === utilities_1.keys.up) {
                e.preventDefault();
                utils_1.focusLastOption(e.target, closeSelectHandler);
                return;
            }
        }
        if (e.key === utilities_1.keys.tab) {
            if (!e.shiftKey &&
                target.nodeName !== 'INPUT' &&
                !target.nextSibling) {
                e.preventDefault();
                utils_1.focusFirstOption(e.target, closeSelectHandler);
                return;
            }
            var searchSibling = (_a = target === null || target === void 0 ? void 0 : target.closest('.Select__search')) === null || _a === void 0 ? void 0 : _a.nextSibling;
            if (!e.shiftKey &&
                target.nodeName === 'INPUT' &&
                !searchSibling) {
                e.preventDefault();
                utils_1.focusFirstOption(e.target, closeSelectHandler);
                return;
            }
        }
        if (target.classList.contains('filter') &&
            (e.key === utilities_1.keys.enter ||
                e.key === utilities_1.keys.space ||
                e.key === utilities_1.keys.down)) {
            onFilterClick(e);
        }
    };
    var handleFocusSearchInput = function () {
        focusDispatch({
            type: utils_1.FocusActionType.SetFocus,
            payload: { searchFocus: true },
        });
    };
    var AnvilSelectHeaderClassNames = classnames_1.default('Select__header', className);
    return (react_1.default.createElement("div", { className: AnvilSelectHeaderClassNames, onKeyDown: handleKeyDown },
        title && (react_1.default.createElement(__1.BodyText, { className: "Select__title ff-display lh-1", bold: true, size: "small" }, title)),
        react_1.default.createElement(__1.Stack, { className: "Select__header-controls w-100" },
            search && (react_1.default.createElement(__1.Stack.Item, { fill: true, className: "Select__search" },
                react_1.default.createElement(__1.Form, null,
                    react_1.default.createElement(__1.Form.Input, __assign({ autoFocus: searchFocus, onFocus: handleFocusSearchInput, icon: "search", iconPosition: "left", size: "small" }, props))))),
            filter && (react_1.default.createElement(__1.Link, { size: 2, className: "Select__filter d-f align-items-center", onClick: onFilterClick },
                react_1.default.createElement("span", { className: "Select__focus filter", tabIndex: 0, ref: filterRef },
                    react_1.default.createElement(__1.Stack, { alignItems: "center" },
                        react_1.default.createElement(__1.Icon, { name: "funnel" }),
                        "Filter",
                        filtersApplied > 0 && (react_1.default.createElement(__1.Tag, { badge: true, compact: true, className: "m-l-half" }, filtersApplied)))))))));
});
//# sourceMappingURL=SelectHeader.js.map